import { identityPhone } from "@/lib/identity-validation";
import { isValidPhoneNumber } from "react-phone-number-input";
import * as Yup from "yup";

// Lead Validation Schema - Campos obrigatórios: nome
export function LeadsValidationSchema() {
  return Yup.object().shape({
    name: Yup.string()
      .required("Nome é obrigatório")
      .min(2, "Nome deve ter pelo menos 2 caracteres")
      .max(100, "Nome não pode ter mais de 100 caracteres"),
    email: Yup.string()
      .email("E-mail inválido")
      .nullable()
      .optional()
      .max(255, "E-mail não pode ter mais de 255 caracteres"),
    phone: Yup.string()
      .test("phone", "Informe um telefone válido com DDD.", value => !value || isValidPhoneNumber(identityPhone(value)))
      .nullable()
      .optional()
      .max(20, "Telefone não pode ter mais de 20 caracteres"),
    company: Yup.string()
      .nullable()
      .optional()
      .max(100, "Empresa não pode ter mais de 100 caracteres"),
    source: Yup.string()
      .nullable()
      .optional()
      .max(100, "Origem não pode ter mais de 100 caracteres"),
    status: Yup.string()
      .nullable()
      .optional()
      .oneOf(['new', 'contacted', 'qualified', 'converted'], 'Status inválido'),
    estimated_value: Yup.number()
      .nullable()
      .optional()
      .min(0, "Valor estimado não pode ser negativo")
      .typeError("Valor estimado deve ser um número"),
    description: Yup.string()
      .nullable()
      .optional()
      .max(1000, "Descrição não pode ter mais de 1000 caracteres")
  });
}

// Stage Validation Schema - Campos obrigatórios: nome, ordem (default: 0)
export function StagesValidationSchema() {
  return Yup.object().shape({
    name: Yup.string()
      .required("Nome é obrigatório")
      .min(2, "Nome deve ter pelo menos 2 caracteres")
      .max(50, "Nome não pode ter mais de 50 caracteres"),
    description: Yup.string()
      .nullable()
      .optional()
      .max(500, "Descrição não pode ter mais de 500 caracteres"),
    order: Yup.number()
      .required()
      .default(0)
      .min(0, "Ordem não pode ser negativa")
      .integer("Ordem deve ser um número inteiro")
      .typeError("Ordem deve ser um número"),
    color: Yup.string()
      .nullable()
      .optional()
      .matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, "Cor inválida. Use formato hexadecimal (#RRGGBB ou #RGB)")
  });
}

// Deal Validation Schema - Campos obrigatórios: título, lead, valor, estágio
export function DealsValidationSchema() {
  return Yup.object().shape({
    title: Yup.string()
      .required("Título é obrigatório")
      .min(2, "Título deve ter pelo menos 2 caracteres")
      .max(200, "Título não pode ter mais de 200 caracteres"),
    lead_id: Yup.lazy((value) => {
      if (Array.isArray(value)) {
        return Yup.array()
          .of(Yup.string().uuid("ID do lead inválido"))
          .min(1, "Selecione pelo menos um lead")
          .required("Lead é obrigatório");
      }
      return Yup.string()
        .required("Lead é obrigatório")
        .uuid("ID do lead inválido");
    }),
    value: Yup.number()
      .required("Valor é obrigatório")
      .min(0, "Valor não pode ser negativo")
      .typeError("Valor deve ser um número"),
    stage_id: Yup.string()
      .required("Estágio é obrigatório")
      .uuid("ID do estágio inválido"),
  });
}

// Filter Validation Schemas
export function LeadFiltersValidationSchema() {
  return Yup.object().shape({
    search: Yup.string().nullable().optional(),
    source: Yup.string().nullable().optional(),
    company: Yup.string().nullable().optional(),
    page: Yup.string().nullable().optional(),
    per_page: Yup.number().nullable().optional()
  });
}

export function StageFiltersValidationSchema() {
  return Yup.object().shape({
    search: Yup.string().nullable().optional(),
    page: Yup.string().nullable().optional(),
    per_page: Yup.number().nullable().optional()
  });
}

export function DealFiltersValidationSchema() {
  return Yup.object().shape({
    search: Yup.string().nullable().optional(),
    lead_id: Yup.string().nullable().optional(),
    stage_id: Yup.string().nullable().optional(),
    status: Yup.string().nullable().optional().oneOf(['open', 'won', 'lost'], 'Status inválido'),
    page: Yup.string().nullable().optional(),
    per_page: Yup.number().nullable().optional()
  });
}

// Export schemas por conveniência
export const CRMValidationSchemas = {
  lead: LeadsValidationSchema,
  stage: StagesValidationSchema,
  deal: DealsValidationSchema,
  leadFilters: LeadFiltersValidationSchema,
  stageFilters: StageFiltersValidationSchema,
  dealFilters: DealFiltersValidationSchema
};